<div class="coin" [style.backgroundColor]="_backgroundColor">
  <span class="coin__text" [style.color]="_color">{{ text | translate }}</span>
</div>
